import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { fieldsToSum, lenderPaidToInclude } from './IBaseDisbursementType';
import { eLenderPaid } from '../../../../../ui-toolkit/enums/eLenderPaid';

export const calculateAmountCentsToDisburse = (
  numberValues: { [key: string]: number } = {},
  stringValues: { [key: string]: string } = {}
) => {
  if (['TRUE', 'true'].includes(stringValues[eFeePropertyNames.NettedOut] ?? '')) {
    return 0;
  }
  let amountCents = fieldsToSum.reduce((p, c) => p + (numberValues[c] || 0) * 100, 0);
  if (lenderPaidToInclude.includes(stringValues[eFeePropertyNames.SendingToSpruce] as eLenderPaid)) {
    amountCents += (numberValues[eFeePropertyNames.OthersPaid] || 0) * 100;
  }
  if (lenderPaidToInclude.includes(stringValues[eFeePropertyNames.SendingToSpruceBuyer] as eLenderPaid)) {
    amountCents += (numberValues[eFeePropertyNames.OthersPaidBuyer] || 0) * 100;
  }
  if (lenderPaidToInclude.includes(stringValues[eFeePropertyNames.SendingToSpruceSeller] as eLenderPaid)) {
    amountCents += (numberValues[eFeePropertyNames.OthersPaidSeller] || 0) * 100;
  }
  // Since we are doing math that should result in an integer, we need to actually make sure it's always an integer.
  // JS math won't do this by default.
  return Math.round(amountCents);
};
